import { render, staticRenderFns } from "./oauth.vue?vue&type=template&id=7da90c36&scoped=true&"
import script from "./oauth.vue?vue&type=script&lang=js&"
export * from "./oauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da90c36",
  null
  
)

export default component.exports